import { FanId } from '@/common/domain/FanId';

export interface BackendConversationToRead {
  senderId: string;
}

export const fromSenderId = (senderId: FanId): BackendConversationToRead => ({
  senderId,
});
